import React from "react";

const NurseRoleIcon = () => {
  return <></>;
};

export default NurseRoleIcon;
